module.exports = __webpack_public_path__ + "static/the-dharma-bums-4cf035532812fc183b953a433f2ac1f6.jpg";